import ConversasList from "./ConversasList";
import ChatView from "./ChatView";

// Layout 35/65 do chat por sessão (clonado do inbox Instagram).
// A seleção de conversa vive no pai (WhatsAppChat) pra resetar ao trocar de sessão.
const DEFAULT_WRAPPER =
  "flex h-[calc(100vh-280px)] min-h-[400px] bg-base border border-white/[0.06] rounded-lg overflow-hidden";

export default function InboxLayout({ sessaoId, socket, wrapperClass, selectedConversaId, onSelect, gravacaoDesligada }) {
  const temSelecao = selectedConversaId !== null && selectedConversaId !== undefined;

  return (
    <div
      className={wrapperClass || DEFAULT_WRAPPER}
      role="main"
      aria-label="Chat da sessão WhatsApp"
    >
      <section
        className={`flex-shrink-0 w-full md:w-[35%] border-r border-white/[0.06] flex flex-col ${
          temSelecao ? "hidden md:flex" : "flex"
        }`}
        aria-label="Lista de conversas"
      >
        <ConversasList
          sessaoId={sessaoId}
          onSelect={onSelect}
          selectedId={selectedConversaId}
          socket={socket}
        />
      </section>

      <section
        className={`flex-1 flex flex-col min-w-0 ${temSelecao ? "flex" : "hidden md:flex"}`}
        aria-label="Visualizador de conversa"
      >
        <ChatView
          sessaoId={sessaoId}
          conversaId={temSelecao ? selectedConversaId : null}
          socket={socket}
          onVoltar={temSelecao ? () => onSelect(null) : undefined}
          gravacaoDesligada={gravacaoDesligada}
        />
      </section>
    </div>
  );
}
